import React from 'react';
import './ApplicationPortal.css';

import hbsLogo from '../assets/HBS_LOGO.png';
import stanfordLogo from '../assets/STANFORD_LOGO.png';
import whartonLogo from '../assets/WHARTON_LOGO.png';
import columbiaLogo from '../assets/COLUMBIA_LOGO.png';
import mitLogo from '../assets/MIT_LOGO.png';
import chicagoBoothLogo from '../assets/CHICAGO_BOOTH_LOGO.png';
import kelloggLogo from '../assets/KELLOGG_LOGO.png';
import berkeleyHaasLogo from '../assets/BERKELEY_HAAS_LOGO.png';
import yaleSomLogo from '../assets/YALE_SOM_LOGO.png';
import dardenLogo from '../assets/DARDEN_LOGO.png';
import uclaAndersonLogo from '../assets/UCLA_ANDERSON_LOGO.png';
import emoryGoizuetaLogo from '../assets/EMORY_GOIZUETA_LOGO.png';

type Portal = {
  id: string;
  school: string;
  portalUrl: string;
  logoSrc: string;
};

const PORTALS: Portal[] = [
  {
    id: 'hbs',
    school: 'Harvard Business School',
    portalUrl: 'https://apply.hbs.edu/apply/',
    logoSrc: hbsLogo
  },
  {
    id: 'stanford',
    school: 'Stanford GSB',
    portalUrl: 'https://applymbamsx.stanford.edu/apply/',
    logoSrc: stanfordLogo
  },
  {
    id: 'wharton',
    school: 'Wharton',
    portalUrl:
      'https://grad-admissions.wharton.upenn.edu/register/?id=e0628d7d-616c-4bed-8fd9-0be9c3eabb83',
    logoSrc: whartonLogo
  },
  {
    id: 'columbia',
    school: 'Columbia Business School',
    portalUrl: 'https://admissions.business.columbia.edu/portal/programs',
    logoSrc: columbiaLogo
  },
  {
    id: 'mit-sloan',
    school: 'MIT Sloan',
    portalUrl: 'https://applymitsloan.mit.edu/register/apply',
    logoSrc: mitLogo
  },
  {
    id: 'chicago-booth',
    school: 'Chicago Booth',
    portalUrl: 'https://www.chicagobooth.edu/admissions/apply',
    logoSrc: chicagoBoothLogo
  },
  {
    id: 'kellogg',
    school: 'Kellogg SOM',
    portalUrl: 'https://admissions.kellogg.northwestern.edu/apply/',
    logoSrc: kelloggLogo
  },
  {
    id: 'berkeley-haas',
    school: 'Berkeley Haas',
    portalUrl: 'https://applynow.haas.berkeley.edu/apply/',
    logoSrc: berkeleyHaasLogo
  },
  {
    id: 'yale-silver-scholars',
    school: 'Yale SOM',
    portalUrl: 'https://admissions.som.yale.edu/apply/?pk=2026',
    logoSrc: yaleSomLogo
  },
  {
    id: 'uva-darden',
    school: 'UVA Darden',
    portalUrl: 'https://apply.darden.virginia.edu/apply/',
    logoSrc: dardenLogo
  },
  {
    id: 'ucla-anderson',
    school: 'UCLA',
    portalUrl:
      'https://www.anderson.ucla.edu/degrees/full-time-mba/ucla-anderson-deferred-enrollment-program',
    logoSrc: uclaAndersonLogo
  },
  {
    id: 'emory-goizueta',
    school: 'Emory Goizueta',
    portalUrl: 'https://goizueta.emory.edu/deferred-mba',
    logoSrc: emoryGoizuetaLogo
  }
];

export default function ApplicationPortal() {
  return (
    <div className="application-portal-page">
      <div className="application-portal-container">
        <header className="application-portal-header">
          <h1 className="application-portal-title">Application Portal</h1>
          <p className="application-portal-subtitle">
            Choose a school to open its official application portal.
          </p>
        </header>

        <div className="application-portal-grid" role="list">
          {PORTALS.map((p) => (
            <a
              key={p.id}
              className="application-portal-tile"
              href={p.portalUrl}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`${p.school} application portal (opens in a new tab)`}
              role="listitem"
            >
              <div className="application-portal-tile-inner">
                <div className="application-portal-logo-wrap" aria-hidden="true">
                  <img
                    src={p.logoSrc}
                    alt=""
                    className="application-portal-logo"
                    loading="lazy"
                  />
                </div>
                <div className="application-portal-school">{p.school}</div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}

